import { OperationalStatus, Store, StoreWithOnlyCoordinates, WeeklyOpeningHours } from '@shared/models';
import { ElasticSearchResponse, StoreDocument } from '@shared/services/elastic-search/models';
import { formatPhone, splitBrandAndStore } from '@shared/utils';

export const storesSerializer = (response: ElasticSearchResponse<StoreDocument>, langcode: string): Store[] => {
  return response.hits.hits.map((hit): Store => {
    const source = hit._source;
    const distance = hit.sort?.[0] ? Math.trunc(hit.sort[0]) : null;
    const searchApiLanguage = source.search_api_language?.[0];
    const weeklyOpeningHours: WeeklyOpeningHours = source.weekly_opening_hours?.[0]
      ? (JSON.parse(source.weekly_opening_hours?.[0]) as WeeklyOpeningHours)
      : null!;
    if (langcode !== searchApiLanguage) {
      return {
        coordinates: {
          lat: source.lat?.[0],
          lng: source.lon?.[0],
        },
      } as StoreWithOnlyCoordinates;
    }
    const name = source.title?.[0] ?? '';
    const operationalStatusRaw = source.operational_status?.[0];
    return {
      uuid: source.uuid?.[0],
      name,
      brandAndStore: splitBrandAndStore(name),
      streetName: source.field_adresse_1?.[0],
      city: source.ville?.[0],
      zipcode: source.field_code_postal?.[0],
      phone: source.field_tel?.[0] ? formatPhone(source.field_tel[0]) : null,
      weeklyOpeningHours: weeklyOpeningHours,
      operationalStatus: operationalStatusRaw ? (JSON.parse(operationalStatusRaw) as OperationalStatus) : null,
      distance: distance,
      coordinates: {
        lat: source.lat?.[0],
        lng: source.lon?.[0],
      },
      url: source.url?.[0],
      langcode: searchApiLanguage,
      isVisioAppointmentAvailable: source?.is_visio_appointment_available?.includes('visio') ?? false,
    };
  });
};
